@use './variables' as *;

:host {
  display: $list-item-host-display;
}

.list-item {
  display: $list-item-display;
  align-items: $list-item-align-items;
  padding-top: $list-item-padding-top;
  padding-right: $list-item-padding-right;
  padding-bottom: $list-item-padding-bottom;
  padding-left: $list-item-padding-left;
  &-text {
    color: $list-item-text-color;
    font-family: $list-item-text-font-family;
    font-weight: $list-item-text-font-weight;
    font-size: $list-item-text-font-size;
    line-height: $list-item-text-line-height;
    margin-right: $list-item-text-margin-right;
    margin-left: $list-item-text-margin-left;
  }
  &-bullet {
    width: $list-item-bullet-width;
    height: $list-item-bullet-height;
    border-radius: $list-item-bullet-border-radius;
    margin: $list-item-bullet-margin;
    background-color: $list-item-bullet-background-color;
  }
  &-order {
    color: $list-item-order-color;
    font-family: $list-item-order-font-family;
    font-size: $list-item-order-font-size;
    font-weight: $list-item-order-font-weight;
    line-height: $list-item-order-line-height;
    text-align: $list-item-order-text-align;
    width: $list-item-order-width;
    min-width: $list-item-order-width;
    height: $list-item-order-height;
    border-radius: $list-item-order-border-radius;
    background-color: $list-item-order-background-color;
  }
  &-checkmark {
    color: $list-item-checkmark-color;
  }
}
